import type { FC } from "react";
import type { FlowItem } from "@/types/flow.ts";
import { assert } from "@/helpers/console.ts";
import { styled } from "@linaria/react";
import { theme } from "@/themes/theme.ts";

interface FlowSmartButtons {
  flowItem: Partial<FlowItem>;
}

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const RadioIndividual = styled.div`
  border: 1px ${theme.brandBorderColor} solid;
  padding: 5px 10px;
  border-radius: ${theme.brandBorderRadius};
  transition: all 0.5s ${theme.transition};

  &:hover {
    scale: 105%;
    z-index: 500;
  }

  &:active {
    scale: 95%;
  }
`;

export const FlowSmartButtons: FC<FlowSmartButtons> = ({ flowItem }) => {
  assert(
    (flowItem.radioButtons?.length ?? 0) !== 0,
    "Flow item radio buttons needs to be more than 0",
  );

  return (
    <RadioWrapper>
      {flowItem.radioButtons?.map((radioButton) => (
        <RadioIndividual
          key={radioButton.value}
          data-tooltip={"Value: " + radioButton.value}
          data-direction="top"
        >
          {radioButton.label}
        </RadioIndividual>
      ))}
    </RadioWrapper>
  );
};
